import React from 'react';
import { withRouter } from 'react-router';
import ShopService from '../service/ShopService';
import ItemDescriptionEditior from '../editor/ItemDescriptionEditior';

class ShopItemEditForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itemId: null,
            itemName: null,
            price: null,
            unit: null,
            description: null,
            isAvailable: null,
            image: null,
            file: null,
            categoryId: null
        };
    }

    onChangeDescription = (event) => {
        this.setState({
            description: event.target.value
        })
    }

    onChangePrice = (event) => {

        this.setState({
            price: event.target.value
        })

    }

    onChangeUnit = (event) => {

        this.setState({
            unit: event.target.value
        })

    }

    onChangeSwitch = (event) => {
        if (this.state.price == null || this.state.price.length < 1) {
            alert("Please Enter Price")
            this.setState({
                isAvailable: false
            })
        } else {
            this.setState({
                isAvailable: !this.state.isAvailable
            })
        }
    }

    exportHtml = (htmlData) => {
        this.setState({
            description: htmlData
        })
    }

    updateShopItem = () => {
        // alert("name "+itemName+ " "+description)
        // event.preventDefault();
        // setIsLoading(true);
        if (this.state.description == null || this.state.description.length < 10) {
            alert("Invalid description, atleast 10 charaters Required")
        } else if (this.state.unit == null || this.state.unit.length < 1) {
            alert("Please select Unit")
        } else {
            const formData = new FormData();

            formData.append("description", this.state.description);
            formData.append("price", this.state.price);
            formData.append("unit", this.state.unit);
            formData.append("itemId", this.state.itemId);
            formData.append("file", this.state.file);
            formData.append("isAvailable", this.state.isAvailable);

            ShopService.updateShopItem(formData).then(res => {

                if (res.status && res.status == 200) {
                    this.props.history.push({
                        pathname: '/shop/items/list/' + this.state.categoryId,
                        state: { category: "test" }
                    })
                }
                // setIsLoading(false);
            }).catch(error => {
                alert("Uploaded Not Completed... Check with Admin")
                // setIsLoading(false);
            });
            // event.preventDefault();
        }
    };

    onFileChange = event => {
        let fileSize = event.target.files[0].size;
        let limitSize = 5000; //5KB
        if (!event.target.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
            alert("Allowed .jpg, .jpeg and .png files")
            event.target.value = null
        } else if (fileSize < limitSize) {
            alert("File size must be greater than 5KB")
            event.target.value = null
        } else {// Update the state

            this.setState({
                image: URL.createObjectURL(event.target.files[0]),
                file: event.target.files[0]
            });
        }
    };

    componentDidMount() {

        // if (this.props.location.state != null) {
            this.setState({
                itemId: this.props.location.state.id,
                itemName: this.props.location.state.name,
                price: this.props.location.state.pricekey,
                unit: this.props.location.state.unitkey,
                description: this.props.location.state.desc,
                image: this.props.location.state.imagekey,
                isAvailable: this.props.location.state.isAvailablekey,
                categoryId: this.props.location.state.categoryId
            })
        // }
    }

    render() {
        const { itemId, itemName, price, unit, description, image, isAvailable } = this.state
        return (
            <div>
                

                <div class='view-shop-item'>

                    <div class='name'>
                        <span>{itemName}  </span>
                    </div>
                    <div class='area'>
                       {description  != null && <ItemDescriptionEditior htmlData={description} exportDataCallBack={this.exportHtml} />}
                        {/* <textarea class="form-control" id="ex" rows="3" spellCheck='false' value={description} onChange={this.onChangeDescription} /> */}
                        <span><button class='btn btn-primary' onClick={this.updateShopItem}>Update</button></span>
                    </div>
                    <div class='opt'>

                        <input type='text' placeholder='Price Rs.' value={price} onChange={this.onChangePrice} />
                        <select class="form-select" value={unit} onChange={this.onChangeUnit} aria-label="size 3 select example">
                            <option key={0} value=''>Select Options</option>
                            <option key={1} value='Grams'>Gram</option>
                            <option key={2} value='Kg'>KG</option>
                            <option key={3} value='ltr'>Liter</option>
                            <option key={3} value='No.'>No.</option>
                        </select>
                        <label class="switch">
                            <input type="checkbox" checked={isAvailable} onChange={this.onChangeSwitch} />
                            <span class="slider round"></span>
                        </label>
                    </div>
                    <div class='ig'>
                        <label for="file-input">
                            <span>Click Image to Update</span>
                            <img src={image} />

                            <input id="file-input" type="file" onChange={this.onFileChange} />
                        </label>
                    </div>

                </div>

            </div>
        );
    }
}

export default withRouter(ShopItemEditForm);
